import {Injectable} from "@angular/core";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable} from "rxjs";
import {CredentialsPayload} from "src/app/infrastructure/moovement-api/models/credentials-payload";
import {User} from "src/app/infrastructure/moovement-api/models/user";
import {AuthenticationMetadata, SessionMetadata} from "src/app/infrastructure/logout.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationApiClient extends MoovementApiClient {



  signIn(uid: string, password: string): Observable<User> {
    const credentials: CredentialsPayload = {
      uid: uid,
      password: password
    };
    return this.httpClient.post<User>(`${this.baseUrl}/api/auth/login`, credentials)
  }

  signOut(authenticationMetadata?: AuthenticationMetadata): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/api/auth/logout`, authenticationMetadata)
  }

  extendSession(sessionMetadata: SessionMetadata) {
    return this.httpClient.post<void>(`${this.baseUrl}/api/auth/session`, sessionMetadata)
  }
}
